/*
 * O ajudante de IA do editor: o botão ✨ entra na barra do TextEditor, ao
 * lado dos botões de formatação. Só se estende a ItemList — o editor tem
 * outro dono, e o que outras extensões põem na barra continua lá.
 *
 * A configuração é lida a cada desenho (o admin pode mudar), e o botão some
 * para quem não pode usar a IA.
 */
import { extend } from 'flarum/common/extend';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import TextEditor from 'flarum/common/components/TextEditor';
import { aiUsable } from '../state';
import { t } from '../../../utils/settings';
import { once } from '../../../utils/chunkGate';

// O menu do ajudante é um chunk, pedido quando o editor aparece com a IA
// ligada. Até chegar, o mesmo botão; um clique nesse meio tempo abre o menu
// assim que ele chega.
const loadHelper = once(() => import(/* webpackChunkName: 'forum/features/ai/helper/HelperMenu', webpackMode: 'lazy-once' */ './HelperMenu').then(mod => mod.default));
let HelperMenu = null;
let openWhenReady = false;
class HelperTrigger extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    if (!HelperMenu) {
      loadHelper().then(menu => HelperMenu = menu).catch(() => {}).finally(() => m.redraw());
    }
  }
  view() {
    if (HelperMenu) {
      const initiallyOpen = openWhenReady;
      openWhenReady = false;
      return m(HelperMenu, {
        editor: this.attrs.editor,
        initiallyOpen: initiallyOpen
      });
    }
    return m("span", {
      className: "CanelaAiHelper"
    }, m(Button, {
      className: "Button Button--icon Button--link ai-helper-trigger",
      icon: "fas fa-wand-magic-sparkles",
      title: t('ai.helper.trigger'),
      "aria-label": t('ai.helper.trigger'),
      "aria-expanded": "false",
      onclick: () => openWhenReady = true
    }));
  }
}
export default function installHelper() {
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    if (!aiUsable('helper') || !this.attrs?.composer) return;
    items.add('canelaAiHelper', m(HelperTrigger, {
      editor: this
    }), -50);
  });
}
flarum.reg.add('ramon-canela', 'forum/features/ai/helper', installHelper);flarum.reg.addChunkModule('forum/features/ai/helper/HelperMenu', './src/forum/features/ai/helper/HelperMenu.tsx', 'ramon-canela', 'forum/features/ai/helper/HelperMenu');